import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  // 注册状态管理全局参数
  state: {
    token: sessionStorage.getItem('satoken') ? sessionStorage.getItem('satoken') : '',
    tokenname: sessionStorage.getItem('tokenname') ? sessionStorage.getItem('tokenname') : '',
    tokenvalue: sessionStorage.getItem('tokenvalue') ? sessionStorage.getItem('tokenvalue') : '',
    userid: sessionStorage.getItem('userid') ? sessionStorage.getItem('userid') : '',
    menu: sessionStorage.getItem('Per') ? sessionStorage.getItem('Per') : '',
    quickLoginType: sessionStorage.getItem('quickLoginType') ? sessionStorage.getItem('quickLoginType') : '',
    platformid: sessionStorage.getItem('platformid') ? sessionStorage.getItem('platformid'): '',
    islogin: sessionStorage.getItem('islogin') ? sessionStorage.getItem('islogin') : '',
    parameters: {} // 保存页面传参
  },
  getters: {
    parameters: state => { // 获取方法
      return state.parameters
    }
  },
  mutations: {
    'SET_TOKEN' (state, token){
      sessionStorage.setItem('tokenname', token.tokenname)
      sessionStorage.setItem('tokenvalue', token.tokenvalue)
      sessionStorage.setItem('satoken', token.tokenvalue)
      state.token = token
      state.tokenname = token.tokenname
      state.tokenvalue = token.tokenvalue
    },
    'ADD_COUNT' (state, token) {
      sessionStorage.setItem('Authorization', token)
      state.token = token
    },
    'REMOVE_COUNT' (state, token) {
      sessionStorage.removeItem('Authorization')
      state.token = token
    },
    'SAVE_PERMISSION' (state, menu) {
      sessionStorage.setItem('Per', menu)
      state.menu = menu
    },
    'DEL_PERMISSION' (state, menu) {
      sessionStorage.removeItem('Per')
      state.menu = menu
    },
    'SET_USERID' (state, userid) {
      sessionStorage.setItem('userid', userid)
      state.userid = userid
    },
    'DEL_USERID' (state, userid) {
      sessionStorage.removeItem('userid')
      state.userid = userid
    },
    'SET_QUICKLOGINTYPE' (state, quickLoginType) {
      sessionStorage.setItem('quickLoginType', quickLoginType)
      state.quickLoginType = quickLoginType
    },
    'SET_PLATFORMID' (state, platformid) {
      sessionStorage.setItem('platformid', platformid)
      state.platformid = platformid
    },
    'SET_ISLOGIN' (state, islogin) {
      sessionStorage.setItem('islogin', islogin)
      state.islogin = islogin
    },
    'REMOVE_ISLOGIN' (state) {
      sessionStorage.removeItem('islogin')
      state.islogin = ''
    },
    setParameters: (state, parametersData) => { // 页面参数传递格式{key:'key',value:'value'}
      if (parametersData) {
        // 试了好久state.parameters[key]=value这样会报错只能先取出来添加属性再赋值
        let parameters = state.parameters
        parameters[parametersData.key] = parametersData.value
        state.parameters = parameters
      }
    }
  }
})
export default store
